import { isNumber } from "lodash";
import { useGrowl } from "PFApp/use_growl";
import Modal from "PFComponents/modal/modal";
import { Button } from "PFCore/components/button";
import { getProfileName } from "PFCore/helpers/profile";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import { fillAndBookRole } from "../api";
import css from "./modals.module.scss";
import FillRoleContent from "./parts/fill_role_content";

const FillRoleModal = ({ close, engagement, role, match, shortlistItem, onSuccess }) => {
  const growl = useGrowl();
  const growlErrors = useErrorsGrowl();
  const { t } = useTranslation("auditPlanner");
  const { isErrorUnauthorized } = useResponseErrors();

  const { profile } = shortlistItem;
  const isSoftOverbooking =
    isNumber(match?.scores.availability_score) && match.scores.availability_score !== 1;

  const confirm = () => {
    fillAndBookRole(shortlistItem.id)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        growl({
          message: t("modals.temporaryBookingCreated", {
            name: getProfileName(profile)
          }),
          kind: "success"
        });
      })
      .catch((response) => {
        if (isErrorUnauthorized(response)) {
          growl({
            kind: "error",
            message: t("modals.cannotFillRole")
          });
        } else {
          growlErrors(response);
        }
      });
  };

  return (
    <Modal style={{ maxWidth: 700, margin: "0 auto" }}>
      <FillRoleContent
        engagement={engagement}
        role={role}
        profile={profile}
        shouldShowSoftOverbooking={isSoftOverbooking}
      >
        <div className={css.buttons}>
          <Button text={t("close")} kind="tertiary" onClick={close} />
          <Button text={t("continue")} onClick={confirm} />
        </div>
      </FillRoleContent>
    </Modal>
  );
};

FillRoleModal.propTypes = {
  close: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  engagement: PropTypes.object.isRequired,
  match: PropTypes.object,
  role: PropTypes.object.isRequired,
  shortlistItem: PropTypes.object.isRequired
};

export default FillRoleModal;
